At adapt, we work hard to maximise trust between individuals, teams and organisations. The application you are about to begin using has been
designed to do this. This simple agreement between you (the "Customer" or "you") and Adapt By Design (“adapt” or “we”) has been written on
the same principle.

<h3>1. Overview</h3>
This agreement explains the terms under which you may use our application (the "Application"). By using the Application, you agree to these
terms.

<h3>2. Licence Grant</h3>
Subject to the terms of this agreement, adapt grants you a licence to access and use this Application for your use. This licence does not
allow you to sell, distribute or modify the Application.

<h3>3. Restrictions</h3>
You may not:
<ul class="list-content">
    <li>Copy, modify, or distribute the Application or any part of it;</li>
    <li>Reverse-engineer, decompile, or attempt to extract the source code of the Application;</li>
    <li>Use the Application for any illegal or unauthorised purpose.</li>
</ul>

<h3>4. Ownership</h3>
Adapt owns all rights, title and interest in the Application, including any updates or modifications. This agreement does not transfer
ownership to you.

<h3>5. Payments</h3>
You agree to make all payments for the Application as specified and when they are due. Failure to do so may result in suspension or
termination of your access to the Application.

<h3>6. Use of your Information</h3>
Adapt may use automatic means (such as cookies and web beacons) to collect information about your use. This information is subject to our
<a href="https://theadaptway.com/privacy-policy"
   target="_blank"
   rel="noopener noreferrer">privacy policy</a>.

<h3>7. Updates</h3>
We may provide updates or improvements to the Application. These are also subject to this agreement.

<h3>8. Termination</h3>
We may terminate the licence if you violate any terms of this agreement. Upon termination, your instance of the Application will be archived
and you will have read only access.

<h3>9. Disclaimer of Warranties</h3>
The Application is provided "as is" without any guarantees or warranties. We are not responsible for any issues or damages resulting from
your use of the Application.

<h3>10. Limitation of Liability</h3>
Our liability to you is limited. We are not responsible for indirect, incidental, or consequential damages related to your use of the
Application.

<h3>11. User Content</h3>
You are responsible for any content you upload or share through the Application ("User Content"). You retain full ownership of your content.
We are not liable for any statements or representations in your content provided by you. You are solely responsible for your content related
to the Application.

<h3>12. Indemnification</h3>
You agree to indemnify and hold us harmless from any claims, damages, losses, liabilities, and expenses (including legal fees) arising out
of or related to your use of the Application, your User Content, or your violation of this agreement or any applicable laws.

<h3>13. Governing Law</h3>
This agreement is governed by the laws of the country within which you are using the Application.

<h3>14. Contact Information</h3>
If you have any questions about this agreement, please contact us at adapt.
